import { render, staticRenderFns } from "./3_PagoMatricula.vue?vue&type=template&id=42604b80&scoped=true"
import script from "./3_PagoMatricula.vue?vue&type=script&lang=ts"
export * from "./3_PagoMatricula.vue?vue&type=script&lang=ts"
import style0 from "./3_PagoMatricula.vue?vue&type=style&index=0&id=42604b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42604b80",
  null
  
)

export default component.exports